<template>
  <div class="l-edit-dialog-box" style="padding-top:0">
    <el-form :model="form_data" label-width="120px" ref="form" :rules="rules" label-position="top" v-loading="loading">
      <!-- <el-divider content-position="left">基础信息</el-divider> -->
      <el-row :gutter="50" style="margin-left:0;margin-right:0">

        <el-col :span="12">
          <el-form-item label="登录名" prop="login_name">
            <el-input v-model="form_data.login_name" autocomplete="off" placeholder="请输入登录用户名" :disabled="isInfo"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="姓名" prop="user_name">
            <el-input v-model="form_data.user_name" autocomplete="off" placeholder="请输入姓名" :disabled="isInfo"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
            <el-form-item label="所属组织架构" prop="org_id">
                <el-cascader v-model="form_data.org_id" :options="org_tree_node" :props="{ checkStrictly: true }" clearable :disabled="org_tree_node.length==0 ||isInfo"
                    @change="changeOrgId(form_data.org_id)"></el-cascader>
          </el-form-item>
        </el-col>
        
        <el-col :span="12">
          <el-form-item label="管理模块类型" prop="moduler_ids">
            <el-select v-model="form_data.moduler_ids" multiple placeholder="请选择模块类型(可多选)" :disabled="moduler_list.length==0 ||isInfo ">
              <el-option v-for="item in moduler_list" :value="item.id" :label="item.name" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        
        <el-col :span="12">
          <el-form-item label="app角色" prop="app_role_id">
            <!-- @change="handleCheckedAllowLoginApp" -->
            <el-switch v-model="form_data.allow_login_app" :active-value="1" :inactive-value="0" 
                :disabled="isInfo" active-text="启用小程序登录">
            </el-switch>
            <!-- <el-checkbox v-model="form_data.allow_login_app" @change="handleCheckedAllowLoginApp">启用登录</el-checkbox> -->
            <el-select v-model="form_data.app_role_id" placeholder="请选择当前app角色" :disabled="app_role_list.length==0 ||isInfo">
              <el-option v-for="item in app_role_list" :value="item.id" :label="item.name" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        
        <el-col :span="12">
          <el-form-item label="admin角色" prop="admin_role_id">
            <!-- @change="handleCheckedAllowLoginadmin" -->
            <el-switch v-model="form_data.allow_login_admin" :active-value="1" :inactive-value="0"
                :disabled="isInfo" active-text="启用管理后台登录">
            </el-switch>
            <!-- <el-checkbox v-model="form_data.allow_login_admin" @change="handleCheckedAllowLoginAdmin">启用登录</el-checkbox> -->
            <el-select v-model="form_data.admin_role_id" placeholder="请选择当前admin角色" :disabled="admin_role_list.length==0 ||isInfo">
              <el-option v-for="item in admin_role_list" :value="item.id" :label="item.name" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        
        <el-col :span="12">
          <el-form-item label="管理的组织架构" prop="managed_org_ids">
            <el-select v-model="form_data.managed_org_ids" multiple placeholder="请选择组织架构(可多选)" :disabled="managed_org_list.length==0 ||isInfo " 
                @change="changeManagedOrgIds(form_data.managed_org_ids)">
              <el-option v-for="item in managed_org_list" :value="item.id" :label="item.org_name" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        
        <el-col :span="12">
          <el-form-item label="管理的消防柜" prop="managed_site_ids">
            <el-select v-model="form_data.managed_site_ids" multiple placeholder="请选择消防柜(可多选)" :disabled="managed_site_list.length==0 ||isInfo ">
              <el-option v-for="item in managed_site_list" :value="item.id" :label="item.site_name" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <template v-if="!isInfo">
            <el-form-item label="密码" prop="pwd">
              <el-row :gutter="50">
                <el-col :span="12">
                  <el-input :type="form_data.pwd=='#none#'?'pwd':'text'" v-model="form_data.pwd" autocomplete="off"  placeholder="请输入登录密码">
                  </el-input>
                </el-col>
                <el-col :span="12">
                  <el-button type="primary" @click="randomWord">生成密码</el-button>
                  <el-button type="success" :disabled="!form_data.pwd||form_data.pwd=='#none#'" v-clipboard:copy="form_data.pwd" v-clipboard:success="copy">复制密码</el-button>
                </el-col>
              </el-row>
            </el-form-item>
          </template>
        </el-col>

        <el-col :span="24">
          <el-form-item label="备注" prop="remark">
            <el-input type="textarea" v-model="form_data.remark" autocomplete="off" :rows="4" maxlength="250" :disabled="isInfo" placeholder="请输入备注" show-word-limit></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="状态" prop="">
            <el-switch v-model="form_data.is_active" :active-value="1" :inactive-value="0" :disabled="isInfo" active-text="启用状态">
            </el-switch>
          </el-form-item>
        </el-col>

      </el-row>
    </el-form>
    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
    </div>
  </div>

</template>

<script>
import Vue from 'vue';
import { randomWord } from "@/utils/Fuc";
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);
export default {
  name: "l-user-edit",
  props: {
    id: {
      type: [Number, String],
      default: null,
    },
     org_id: {
      type: [Number, String],
      default: null,
    },
    visible: {
      type: Boolean,
    },
    isInfo: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasId() {
      return this.$props.id !== null;
    },
  },
  data() {
    return {
      loading: false, //页面是否加载中

      show_org_id_select: false,

      org_tree_node: [],
      app_role_list: [],
      admin_role_list: [],
      role_list: [],
      community_list: [],
      moduler_list: [],
      role_highest_id: [],
      street_list: [],
      //
			company_list: [],
      department_list:[],
      managed_org_list:[],
      managed_site_list:[],
      defaultProps: {
        children: "children",
        label: "name",
      },
      //表单数据
      form_data: {
        login_name: "",
        org_id: "",
        state: 1,
        pwd: "",
        re_pwd: "",
        remark: "",
        role_ids: "",
        user_name: "",
        department_id:"",
        moduler_ids:[],
        managed_org_ids:[],
        managed_site_ids:[],
        allow_login_app: true,
        allow_login_admin: true,
      },
      //表单验证规则
      rules: {
        login_name: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "change",
          },
        ],
        user_name: [
          {
            required: true,
            message: "姓名不能为空",
            trigger: "change",
          },
        ],
        org_id: [
          {
            required: true,
            message: "所属组织架构不能为空",
            trigger: "change",
          },
        ],
        app_role_id: [
          {
            required: true,
            message: "请选择app角色",
            trigger: "change",
          },
        ],
        admin_role_id: [
          {
            required: true,
            message: "请选择admin角色",
            trigger: "change",
          },
        ],
        pwd: [
          {
            required: true,
            message: "请输入登录密码",
            trigger: "change",
          },
        ],

        state: [
          {
            type: "number",
            required: true,
            message: "请选择状态",
            trigger: "change",
          },
        ],
      },
      //提交按钮是否显示加载中
      submitting: false,
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getData();
        }
      },
    },
  },
  mounted() {
      // if (this.form_data.allow_login_app == 1) {
      //     this.form_data.allow_login_app = true;
      // } else {
      //     this.form_data.allow_login_app = false;
      // }
      
      // if (this.form_data.allow_login_admin == 1) {
      //     this.form_data.allow_login_admin = true;
      // } else {
      //     this.form_data.allow_login_admin = false;
      // }
      // console.log(this.form_data.allow_login_app);
  
  },

  methods: {
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit("update:visible", false);
    },

    //获取数据
    getData() {
      this.loading = true;
      if (this.hasId) {
        this.$_invoke("uniUser_getUpdateData", {
          id: this.$props.id,
          // pid_ids: this.form_data.street_ids
        })
          .then((ret) => {
            // console.log(ret)
            this.form_data = ret.data;
            this.org_tree_node = ret.org_tree_node;
            // this.community_list = ret.community_list;
            // this.street_list = ret.street_list;
            // this.role_highest_id = ret.role_highest_id;
            this.app_role_list = ret.app_role_list;
            this.admin_role_list = ret.admin_role_list;
            this.moduler_list = ret.moduler_list;
            this.managed_org_list = ret.managed_org_list;
            this.managed_site_list = ret.managed_site_list;
            // this.company_list = ret.company_list;
            // this.department_list = ret.department_list;
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.$_invoke("uniUser_getAddData", {
          pid_ids: this.form_data.street_ids,
          org_id:this.$props.org_id
        })
          .then((ret) => {
            this.form_data.org_id = ret.data.org_id;
            this.org_tree_node = ret.org_tree_node;
            this.app_role_list = ret.app_role_list;
            this.admin_role_list = ret.admin_role_list;
            // this.community_list = ret.community_list;
            // this.role_highest_id = ret.role_highest_id;
            // this.street_list = ret.street_list;
            this.moduler_list = ret.moduler_list;
            this.managed_org_list = ret.managed_org_list;
            this.managed_site_list = ret.managed_site_list;
            // this.company_list = ret.company_list;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    // 根据传入的所属 orgid，返回所管理的 orglist
    changeOrgId(orgid) {
        console.log(orgid);
        let sel_org_id = orgid
        if (typeof sel_org_id != "number") {
          const pid_len = sel_org_id.length;
          sel_org_id = sel_org_id[pid_len - 1];
        }
        this.loading = true;
        this.$_invoke(`uniOrg_getOrgList`, {sel_org_id }).then((ret) => {
            this.managed_org_list = ret.org_list;       
        }).finally(() => {
          this.loading = false;
        });
    },
    
    // 根据传入的所管理的 orgids，返回所管理的 sitelist
    changeManagedOrgIds(OrgIds) {
        console.log(OrgIds);
        
        this.loading = true;
        this.$_invoke(`site_getSiteList`, {OrgIds }).then((ret) => {
            this.managed_site_list = ret.site_list;       
        }).finally(() => {
          this.loading = false;
        });
    },
    
    //生成随机密码
    randomWord() {
      this.form_data.pwd = randomWord(true, 6, 6);
    },

    //点击复制链接
    copy(e) {
       console.log(e.text);
      this.$_msg.success("复制成功");
    },

    //提交数据
    handleSubmit() {
      if (this.loading) return;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitting = true;
          
          let sel_org_id = this.form_data.org_id
          if (typeof sel_org_id != "number") {
            const pid_len = sel_org_id.length;
            sel_org_id = sel_org_id[pid_len - 1];
          }
          this.form_data.org_id = sel_org_id
          
          if (!this.hasId) {
            //添加
            // this.form_data.mobile = this.form_data.username;
            // this.form_data.org_id = this.$props.org_id;
            this.$_invoke("uniUser_save", this.form_data)
              .then(() => {
                this.$_msg.success("添加成功");
                this.$emit("on-success");
              })
              .finally(() => {
                this.submitting = false;
              });
          } else {
            //修改
            this.form_data.id = this.$props.id;
            // this.form_data.mobile = this.form_data.username;
            this.$_invoke("uniUser_update", this.form_data)
              .then(() => {
                this.$_msg.success("修改成功");
                this.$emit("on-success");
              })
              .finally(() => {
                this.submitting = false;
              });
          }
        }
      });
    },
    // app/admin 登录checkbox
    handleCheckedAllowLoginApp(val) {
        if (val == false) {
            this.form_data.app_role_id='';
        } 
    },
    handleCheckedAllowLoginAdmin(val) {
        if (val == false) {
            this.form_data.admin_role_id='';
        }
    },
    
  },
};
</script>